//var stripe = Stripe('pk_test_Mypvjtno5F7RLRJFhQ4QQKAP', {
//    betas: ['payment_intent_beta_3']
//});

function loadScript(url, callback) {
    var script = document.createElement("script")
    script.type = "text/javascript";
    if (script.readyState) {  // only required for IE <9
        script.onreadystatechange = function () {
            if (script.readyState === "loaded" || script.readyState === "complete") {
                script.onreadystatechange = null;
                callback();
            }
        };
    } else {  //Others
        script.onload = function () {
            callback();
        };
    }

    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
}

//loadScript('https://js.stripe.com/v3', function () {
//    alert('script ready!');
//});

var stripe;
var card;

loadScript('https://js.stripe.com/v3', function () {
    //stripe = Stripe('pk_test_Mypvjtno5F7RLRJFhQ4QQKAP', {
    //    betas: ['payment_intent_beta_3']
    //});
    stripe = Stripe('pk_live_JsW8kqrlLctqAV6cv7yE5DQU', {
        betas: ['payment_intent_beta_3']
    });

    var elements = stripe.elements({
        fonts: [
            {
                family: '"Nunito Sans"',
                src: 'local("Nunito Sans Light"), local("NunitoSans-Light"), url(https://fonts.gstatic.com/s/nunitosans/v6/pe03MImSLYBIv1o4X1M8cc8WAf5v.woff2) format("woff2"), url(https://fonts.gstatic.com/s/nunitosans/v6/pe03MImSLYBIv1o4X1M8cc8WAf5p.woff) format("woff")',
                weight: 300,
                style: 'normal',
                display: 'swap'
            },
            {
                family: '"Nunito Sans"',
                src: 'local("Nunito Sans ExtraLight Italic"), local("NunitoSans-ExtraLightItalic"), url(https://fonts.gstatic.com/s/nunitosans/v6/pe01MImSLYBIv1o4X1M8cce4GxZrU1E.woff2) format("woff2"), url(https://fonts.gstatic.com/s/nunitosans/v6/pe01MImSLYBIv1o4X1M8cce4GxZrU1c.woff) format("woff")',
                weight: 200,
                style: 'italic',
                display: 'swap'
            }
        ]
    });

    var style = {
        base: {
            fontFamily: '"Nunito Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
            fontWeight: 300,
            fontSize: '16px',
            lineHeight: '24px',
            color: '#333',
            '::placeholder': {
                fontStyle: 'italic',
                fontWeight: 200,
                color: '#999'
            }
        },
        invalid: {
            color: '#dc3545',
            iconColor: '#dc3545'
        }
    };

    // Create an instance of the card Element
    card = elements.create('card', {
        hidePostalCode: true,
        style: style
    });

    if ($('#BillingForm').length) {
        // Add an instance of the card Element into the 'card-element' <div>
        if ($('#card-element').length) {
            card.mount('#card-element');
        }

        $('#BillingForm').on('submit', function () {
            if ($('#BillingForm').valid()) {
                //fbq('track', 'AddPaymentInfo'); // Facebook Pixel Code
                var FBImage = $('<img />').attr('src', 'https://www.facebook.com/tr?id=1114355628683663&amp;ev=AddPaymentInfo').css('display', 'none').attr('width', '1').attr('height', '1');
                $('body').append(FBImage);
                //< img src = "https://www.facebook.com/tr?id={pixel-id}&amp;ev=InitiateCheckout" height = "1" width = "1" style = "display:none" />
                $('button').prop('disabled', true);
                $('a.btn').addClass('disabled');
                $('.payButton .fas').removeClass('fa-lock-alt').addClass('fa-circle-notch fa-spin');
            }
        });
    }

});